import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { TriggerDto } from "@api";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { filter, first } from "rxjs/operators";
import { RootState } from "src/app/store";
import * as FromScenario from "src/app/store/scenario/selectors";

@Component({
  selector: "app-action-params-info",
  templateUrl: "./action-params-info.component.html",
  styleUrls: ["./action-params-info.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionParamsInfoComponent implements OnInit {
  public shouldShowEventScopedVariables: boolean = false;

  private scenarioTrigger$: Observable<TriggerDto> = this.store.select(FromScenario.getScenarioTrigger);
  private eventScopedTriggers: string[] = ["CONFIRMED_ATTENDANCE_TO_EVENT", "CANCELLED_ATTENDANCE_TO_EVENT", "NEW_EVENT_CREATED"];

  constructor(private store: Store<RootState>) {}

  public ngOnInit(): void {
    this.scenarioTrigger$
      .pipe(
        filter(trigger => !!trigger),
        first(),
      )
      .subscribe(trigger => {
        this.shouldShowEventScopedVariables = this.eventScopedTriggers.includes(trigger.value);
      });
  }
}
